export default "/_next/static/images/product-notifications-ee8919b0cedd92d478c9354abc274d93.svg";